<form [formGroup]="noteForm" (ngSubmit)="submit()">
    <div class="modal-header">
        <h4 class="modal-title" [innerHtml]="title"></h4>
    </div>
    <div class="modal-body">
        <p [innerHtml]="message"></p>
        <div class="form-group">
            <p *ngIf="textAreaInstructions">{{textAreaInstructions}}</p>
            <textarea placeholder="Enter any comments here..." class="note form-control" formControlName="Message"></textarea>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-info yes-button" (click)="submit()">Yes</button>
        <button type="button" class="btn btn-info no-button" (click)="activeModal.dismiss('cancel')">No</button>
    </div>
    
</form>
